import { render } from "./StretchingGame.vue?vue&type=template&id=02d61bce&scoped=true"
import script from "./StretchingGame.vue?vue&type=script&lang=js"
export * from "./StretchingGame.vue?vue&type=script&lang=js"

import "./StretchingGame.vue?vue&type=style&index=0&id=02d61bce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d61bce"]])

export default __exports__